"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const GenericSelectionOverlay_1 = __importDefault(require("./GenericSelectionOverlay"));
const DocumentSettingsContext_1 = require("../../context/DocumentSettingsContext");
const generateDocumentStyles_1 = require("../../utils/generateDocumentStyles");
const api_1 = require("../../api");
const RichTextEditorToolbar_1 = __importDefault(require("../RichTextEditorToolbar"));
const SessionBuilderContext_1 = require("../../context/SessionBuilderContext");
const PDFPreview = ({ code, isDragging, isEditing }) => {
    const { settings } = (0, DocumentSettingsContext_1.useDocumentSettings)();
    const [editorHtml, setEditorHtml] = react_1.default.useState("");
    const { setGeneratedCode } = (0, SessionBuilderContext_1.useSessionBuilder)();
    const wasEditingRef = react_1.default.useRef(false);
    react_1.default.useEffect(() => {
        setEditorHtml(code);
    }, [code]);
    // Wrap each page
    const wrapPages = (html) => {
        const pages = html.split('<div class="page-break"></div>');
        return pages
            .map((pageContent, index) => {
            // Replace nested pdf-page with content class
            const cleanedContent = pageContent.replace(/class=["']pdf-page["']/g, "class='content'");
            return `
          <div class="pdf-page">
            ${settings.headerFooter.showHeader ? `<div class="header">${settings.headerFooter.headerText || ''}</div>` : ''}
              ${cleanedContent}
            ${settings.headerFooter.showFooter ? `<div class="footer">${settings.headerFooter.footerText || ''}</div>` : ''}
            ${settings.pdf.includePageNumbers ? `<div class="page-number">${index + 1}</div>` : ''}
          </div>
        `;
        })
            .join('');
    };
    const pageContent = wrapPages(code);
    const htmlWithStyles = `
    <html>
      <head>
        <style>
          ${(0, generateDocumentStyles_1.generateDocumentStyles)(settings, api_1.DOC_TYPE.PDF)}
          .pdf-container {
            display: flex;
            flex-direction: column;
            gap: 20px;
          }
        </style>
      </head>
      <body>
        <div class="pdf-container">
          ${pageContent}
        </div>
      </body>
    </html>
  `;
    const editorContentStyle = `
    ${(0, generateDocumentStyles_1.generateDocumentStyles)(settings, api_1.DOC_TYPE.PDF)}
    .pdf-container { display: flex; flex-direction: column; gap: 20px; }
  `;
    const unwrapFromEditor = (html) => {
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const pageNodes = Array.from(doc.querySelectorAll('.pdf-page'));
            if (pageNodes.length === 0)
                return html;
            const contents = pageNodes.map((page) => {
                const content = page.querySelector('.content');
                return content ? content.innerHTML : page.innerHTML;
            });
            return contents.join('<div class="page-break"></div>');
        }
        catch (_a) {
            return html;
        }
    };
    react_1.default.useEffect(() => {
        if (wasEditingRef.current && !isEditing) {
            const raw = unwrapFromEditor(editorHtml);
            setGeneratedCode(raw);
        }
        wasEditingRef.current = !!isEditing;
    }, [isEditing, editorHtml, setGeneratedCode]);
    // (commit handled above when toggling off edit mode)
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { position: "relative", height: "100%" }, children: isEditing ?
            (0, jsx_runtime_1.jsx)(RichTextEditorToolbar_1.default, { value: editorHtml, onChange: setEditorHtml, disabled: isDragging, contentStyle: editorContentStyle })
            :
                (0, jsx_runtime_1.jsx)(GenericSelectionOverlay_1.default, { code: htmlWithStyles, title: "PDF Preview", iframeStyle: { minHeight: "500px", overflowY: "scroll" }, isDragging: isDragging }) }));
};
exports.default = PDFPreview;
